import TopBar from '../layout/TopBar';
import TemplateList from './TemplateList';

export default function TemplatesScreen({ active }) {
  return (
    <section className={`screen${active ? ' active' : ''}`}>
      <TopBar
        title="テンプレート"
        action={
          <button className="icon-btn" title="並び替え" type="button">
            ⇅
          </button>
        }
      />
      <div className="section-label">よく使う予定をワンタップで登録</div>
      <TemplateList />
    </section>
  );
}
